import ManageContentScreen from '../components/ManageContentScreen';

const ManageVideos = () => {
  return (
    <ManageContentScreen
      type="videos"
      title="Manage Videos"
      backPath="/profile"
    />
  );
};

export default ManageVideos;
